import {CustomerContactPerson} from './CustomerContactPerson';
import {CustomerAddress} from './CustomerAddress';
import {ProductType} from './ProductType';
import {ProductContent} from './ProductContent';
import {ProductCategory} from './ProductCategory';
import {BaseObject} from './BaseObject';

export class Pohoda extends BaseObject {
    id: number;
}



// WEBPACK FOOTER //
// /app/src/model/Entities/Pohoda.ts